import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import defaultLogo from '../../assets/images/png/cx-logo-new.png';
@inject('configurationsStore') @observer

export default class LogoImage extends Component {

    render() {
        
        return this.props.configurationsStore.isMultitenancyMode === false ? 
                    <div style={this.props.style}>
                        <img src={'/images/cx-logo.png'} style={{height: '100%'}} onError={(e) => {e.target.onerror = null; e.target.src=defaultLogo;}}
                        />
                    </div> :                     
                    <div style={this.props.style}>
                        <img src={defaultLogo} style={{height: '100%'}} />
                    </div>;
    }
}